import url from './url';

async function getModulos(token, cd_curso) {

    let data = await fetch(`${url}/modulo/curso/${cd_curso}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

async function showModulo(token, id) {

    let data = await fetch(`${url}/modulo/${id}`, {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + token
        },
        method: 'get'
    }).then(res => res.json());

    return data;

}

export { getModulos, showModulo }